import React, { ReactNode } from 'react';

import { Box, IconButton, Separator, VStack, WorkflowHeader } from '@betterment/samba-react';

import { useCustomFundLineup } from '../../contexts/CustomFundLineupContext';
import Footer from '../Footer';

interface CustomFundLineupLayoutProps {
  children: ReactNode;
  onBack?: () => void;
  onClose?: () => void;
}

export const CustomFundLineupLayout: React.FC<CustomFundLineupLayoutProps> = ({ children, onBack, onClose }) => {
  const { returnTo } = useCustomFundLineup();

  const defaultReturnPath = '/';
  const returnPath = returnTo || defaultReturnPath;

  const handleBack = onBack || (() => window.location.assign(returnPath));
  const handleClose = onClose || (() => window.location.assign(returnPath));

  return (
    <VStack css={{ minHeight: '100vh', bg: 'background.surface' }}>
      <Box css={{ width: '100%', px: 'space.400', bg: 'background.surface' }}>
        <WorkflowHeader css={{ maxWidth: 'none', width: '100%', py: 'space.200' }}>
          <WorkflowHeader.Leading>
            <IconButton name="LeftArrow" label="Go back" onClick={handleBack} variant="ghostSecondary" />
          </WorkflowHeader.Leading>
          <WorkflowHeader.Title>Create custom fund lineup</WorkflowHeader.Title>
          <WorkflowHeader.Trailing>
            <IconButton name="X" label="Close" onClick={handleClose} variant="ghostSecondary" />
          </WorkflowHeader.Trailing>
        </WorkflowHeader>
      </Box>
      <Separator />

      {children}

      <Footer />
    </VStack>
  );
};
